export class UserGroupBaseView {

    id: number;
    name: string;
    description: string;

    constructor(data?: any) {

        this.id = data?.id ?? 0;
        this.name = data?.name ?? "";
        this.description = data?.description ?? "";
    }
}